/* ================================================== */
/* LINKS → Scroll top
/* ================================================== */

function scrollTop(event) {
	event.preventDefault();
	var page = $('html, body');

	// Stop auto-scroll if user scroll
	page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() { page.stop() });

	// Auto-scroll
	page.animate({ scrollTop: 0 });
}

$(document).ready(function() {

	// Scroll to top on click
	$('.scroll-top').click(function(event) {
		scrollTop(event);
	});

});